import React, { useMemo } from 'react';
import landauThumbnail from '../assets/landau-thumbnail.jpg';
import bedroomThumb from '../assets/bedroom.jpg';
import livingRoomThumb from '../assets/living-room.jpg';
import exteriorThumb from '../assets/exterior.jpg';
import frontRight from '../assets/front-right.jpg';
import backPatio from '../assets/back-patio.jpg';
import backHigh from '../assets/back-high.jpg';
import loft from '../assets/loft.jpg';
import masterBathroom from '../assets/master-bathroom.jpg';
import mrphVideoThumb from '../assets/front-left.jpg';
import mapThumb from '../assets/map-thumb.png';
import constructionMap from '../assets/House_Final_Pro.pdf';

const portfolioItems = [
  { id: 5, title: '705 Landau Rd', mediaType: 'embed', thumbnail: landauThumbnail, url: 'https://player.vimeo.com/video/1193734374?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479', category: 'realestate' },
  { id: 11, title: 'Master Bedroom', mediaType: 'photo', thumbnail: bedroomThumb, url: bedroomThumb, category: 'realestate' },
  { id: 12, title: 'Spacious Living Room', mediaType: 'photo', thumbnail: livingRoomThumb, url: livingRoomThumb, category: 'realestate' },
  { id: 13, title: 'Stunning Exterior', mediaType: 'photo', thumbnail: exteriorThumb, url: exteriorThumb, category: 'realestate' },
  { id: 14, title: 'Front Right Exterior', mediaType: 'photo', thumbnail: frontRight, url: frontRight, category: 'realestate' },
  { id: 15, title: 'Back Patio', mediaType: 'photo', thumbnail: backPatio, url: backPatio, category: 'realestate' },
  { id: 16, title: 'Back High Angle', mediaType: 'photo', thumbnail: backHigh, url: backHigh, category: 'realestate' },
  { id: 17, title: 'Loft', mediaType: 'photo', thumbnail: loft, url: loft, category: 'realestate' },
  { id: 18, title: 'Master Bathroom', mediaType: 'photo', thumbnail: masterBathroom, url: masterBathroom, category: 'realestate' },
  { id: 19, title: 'Forrest Creek Video Tour', mediaType: 'embed', thumbnail: mrphVideoThumb, url: 'https://player.vimeo.com/video/1191913158?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479', category: 'realestate' },
  { id: 20, title: 'Construction Progress Map', mediaType: 'pdf', thumbnail: mapThumb, url: constructionMap, category: 'mapping' },
];

export const PortfolioSection = React.forwardRef(({ selectedFilter, setSelectedFilter, setSelectedItem }, ref) => {
  const filteredItems = useMemo(
    () => (selectedFilter === 'all' ? portfolioItems : portfolioItems.filter(item => item.category === selectedFilter)),
    [selectedFilter]
  );

  return (
    <section ref={ref} className="py-12 bg-slate-950">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-4xl font-bold text-white mb-2 text-center">Our Portfolio</h2>
        <p className="text-slate-400 text-center mb-8">Real Estate Photography & Construction Mapping in South Charlotte</p>

        <div className="flex flex-wrap gap-4 justify-center mb-12">
          <button onClick={() => setSelectedFilter('realestate')} className={`px-10 py-5 rounded-3xl text-xl font-semibold transition-all shadow-lg flex-1 max-w-[320px] min-w-[260px] ${selectedFilter === 'realestate' ? 'bg-sky-600 text-white scale-105' : 'bg-slate-800 text-white hover:bg-slate-700 border border-slate-600'}`}>📸 Real Estate Portfolio</button>
          <button onClick={() => setSelectedFilter('mapping')} className={`px-10 py-5 rounded-3xl text-xl font-semibold transition-all shadow-lg flex-1 max-w-[320px] min-w-[260px] ${selectedFilter === 'mapping' ? 'bg-emerald-600 text-white scale-105' : 'bg-slate-800 text-white hover:bg-slate-700 border border-slate-600'}`}>🗺️ Construction Mapping Portfolio</button>
          <button onClick={() => setSelectedFilter('all')} className={`px-10 py-5 rounded-3xl text-xl font-semibold transition-all shadow-lg flex-1 max-w-[320px] min-w-[260px] ${selectedFilter === 'all' ? 'bg-slate-700 text-white' : 'bg-slate-800 text-white hover:bg-slate-700 border border-slate-600'}`}>All Projects</button>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredItems.map(item => (
            <div key={item.id} onClick={() => setSelectedItem(item)} className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-xl shadow-lg">
                <img src={item.thumbnail} alt={item.title} className="w-full aspect-video object-cover transition group-hover:scale-105" />
                <div className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/50 transition-all">
                  <div className="w-20 h-20 bg-white/95 hover:bg-white rounded-3xl flex items-center justify-center shadow-2xl transition-all group-active:scale-95">
                    {item.mediaType === 'embed' ? (
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-12 h-12 text-slate-900 ml-1" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5.14v14.72L18 12 8 5.14z" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-12 h-12 text-slate-900" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 01-14 0 7 7 0 0114 0z" />
                      </svg>
                    )}
                  </div>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-4">
                  <h3 className="text-white font-semibold text-lg">{item.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});
